import { IComponentOptions } from "angular";
import { DailyReadingsGraphController } from "./controller";

export const vsComponentName = "dailyReadingsGraphComponent";

export const dailyReadingsGraphComponentOptions: IComponentOptions = {
  controller: DailyReadingsGraphController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    progressivesContext: "<",
  },
};
